import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

/**
 * Generated class for the MenuPartialRatioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-combo-partial-ratio',
    templateUrl: 'combo-partial-ratio.html',
})
export class ComboPartialRatioPage {
    @Input() color: string;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }



}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-list/combo-partial-ratio/combo-partial-ratio.ts